import axios from "axios";

export const getTotalUsers = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/v1/total-user`,
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};


const createPassword = async (email, password) => {
  try {
    const passwordRes = await axios.post(
      "https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/admin-create-password",
      { email, password } // ✅ body as an object
    );

    return passwordRes; // ✅ return response
  } catch (error) {
    console.error("Error creating password:", error);
    throw error; // rethrow for handling in UI
  }
};

export default createPassword;

export const getAdmins = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/v1/list-admin`,
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};
export const getTotalValidators = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/v1/total-validators`,
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};
export const getUsers = async (type, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/v1/list-user?sub_type=${type}`,
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};
export const getValidators = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/v1/list-validators`,
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const getEmissionHistory = async (page, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/v1/list-emissions?limit=12&page=Page${page}`,

      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};
export const getEmissionHistoryByFacility = async (token, range) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/v1/user-total-emissions?time-range=${range}`,
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};


export const UpdateAdmin = async (updatedData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.post(
      "https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/update-admin",
      updatedData, // ✅ This is the actual data being sent
      config // ✅ Config (headers) go here
    );

    console.log("Response:", res.data);
    return res.data;
  } catch (error) {
    console.error("ERROR:", error.response?.data || error.message);
    throw error; // Optional: rethrow so it can be handled by caller
  }
};


export const getAdminById = async (params, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
     `https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/get-admin?admin_id=${params}`,
      
      config
    );
console.log(res.data)
    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};


export const deleteAdmin = async (token, id) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data: {
      admin_id: id, // ✅ Send ID in body
    },
  };

  try {
    const res = await axios.delete(
      "https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/remove-admin",
      config
    );
    return res.data;
  } catch (error) {
    console.error("ERROR:", error.response?.data || error.message);
    throw error;
  }
};


export const updateUserKyc = async (
  updateType,
  subscriptionPlan,
  facilityName,
  walletAddress,
  facilityDescription,
  facilityLocation,
  facilityCategory,
  sustainabilitySolution,
  quantificationMethodology,
  fuelSource,
  renewableEnergySolutions,
  governmentOrganization,
  regulatoryStatus,
  id,
  token
) => {
  console.log('id', {
    updateType,
    subscriptionPlan,
    facilityName,
    walletAddress,
    facilityDescription,
    facilityLocation,
    facilityCategory,
    sustainabilitySolution,
    quantificationMethodology,
    fuelSource,
    renewableEnergySolutions,
    governmentOrganization,
    regulatoryStatus,
    id,
  });
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/kyc/v1/update-kyc?user_id=${id}`,
      {
        updateType,
        userId: id,
        subscriptionPlan,
        facilityName,
        walletAddress,
        facilityDescription,
        facilityLocation,
        facilityCategory,
        sustainabilitySolution,
        quantificationMethodology,
        fuelSource,
        renewableEnergySolutions,
        governmentOrganization,
        regulatoryStatus
      },
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response;
  }
};

export const updateUserKycUser = async (
  updateType,
  location,
  quantifiedBasedYearEmission,
  projectDescriptionDocument,
  id,
  token
) => {
  console.log('id', {
    updateType,
    location,
    quantifiedBasedYearEmission,
    projectDescriptionDocument,
    id,
    token
  });
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/kyc/v1/update-kyc?user_id=${id}`,
      {
        updateType,
        userId: id,
        location,
        quantifiedBasedYearEmission,
        projectDescriptionDocument
      },
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
    return error?.response;
  }
};

export const registerNonGreenDevice = async (
  facilityType,
  fuelType,
  id,
  token
) => {
  const config = {
    headers: {
      Authorization:` Bearer ${token}`,
    },
  };
  console.log({
    facilityType,
    fuelType
  });
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/admin/v1/register-sensor?user_id=${id}`,
      { facilityType, fuelType },
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const registerGreenDevice = async ({
  token,
  id,
  facilityType,
  solarType,
  renewableSource,
  fuelType: baselineEnergySource, // Rename parameter
}) => {
  console.log('id', id);
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/admin/v1/register-sensor?user_id=${id}`,
      { 
        facilityType, 
        renewableSource, 
        solarType, 
        fuelType: baselineEnergySource // Use the renamed variable
      },
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const getWeeklyEmission = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/v1/list-weekly-emission`,
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};



export const updateIotDate = async (type, date_value, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    console.log(
      {
        type, date_value, token
      }
    );

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/iot/v1/admin/update-iot-dates?update=${type}`,
      {
        date_value,
      },
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};


export const getNdcRequests = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/ndc/v1/list-ndc-requests`,
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const updateNdcRequest = async (status, requestId, userId, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/admin/v1/approve-ndc-value`,
      {
        status,
        requestId,
        userId
      },
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};


export const getDonors = async (page, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/donation/v1/list-donors?limit=10&page=Page${page}`,

      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const getTotalDonationBalance = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/donation/v1/total-donation-balance`,

      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};


export const getCCRTByMonth = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/ccrt/v1/total-trades`,

      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};
export const getTotalCCRTBalance = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/donation/v1/total-donation-spent`,

      config
    );

    return res; // this value is in niara
  } catch (error) {
    console.log("ERROR", error);
  }
};
export const getCcrtTrades = async (page, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/ccrt/v1/list-trades?limit=10&page=Page${page}`,

      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

/** Website APIs **/
export const createBlogPost = async (title, intro, content, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/admin/v1/create-blog`,
      {
        title,
        intro,
        content,
      },
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};


export const getBlogPosts = async (page = 1) => {
  console.log(page);
  // const config = {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  // };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/open/v1/get-blog-posts?limit=2&page=Page${page}`,
      // config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const getDemoRequests = async (token, page = 1) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/v1/get-demo-request?limit=10&page=Page${page}`,
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const verifyDemoRequests = async (
  id,
  token
) => {
  console.log('id', id);
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/admin/v1/verify-demo-request?demo_id=${id}`,
      { approvalStatus: "approved" },
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};
export const sendEmail = async (
  email,
  title,
  body,
  token
) => {
  console.log(
    "email",
    email,
    "title",
    title,
    "body",
    body,
    "token",
    token
  );
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/admin/v1/send-email`,
      { email, title, body },
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};

export const getTemplateSubmission = async (id, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/v1/onboarding-template?demo_id=${id}`,
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};
/** Website APIs **/

export const verifyAdmin = async (email) => {
 
  try {
    const res = await axios.post(
      "https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/verify-admin",
      { email },
    
    );  
    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};


